import React, { useState } from "react";
import {
  Button,
  Box,
  Typography,
  TextField,
  Stack,
  Paper,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SlidingSidebar, { ButtonControls } from "../Components/SlidingSidebar";

const AddBA: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const generatePassword = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let password = "";
    for (let i = 0; i < 10; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setFormData((prev) => ({ ...prev, password }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle user creation logic here
    console.log("User created:", formData);
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        startIcon={<CloudUploadIcon />}
      >
        Add User
      </Button>

      <SlidingSidebar open={open} onClose={handleClose} width="500px">
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ flexGrow: 1, overflow: "auto", pb: 2 }}>
            <Stack spacing={0.5} sx={{ p: 2 }}>
              <Paper elevation={0} sx={{ p: 1 }}>
                <Stack spacing={2}>
                  <Typography variant="h6">Basic Information</Typography>
                  <TextField
                    label="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    size="small"
                    fullWidth
                    required
                  />
                  <TextField
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    size="small"
                    fullWidth
                    required
                  />
                  <TextField
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    size="small"
                    fullWidth
                    required
                  />
                </Stack>
              </Paper>

              <Paper elevation={0} sx={{ p: 1 }}>
                <Stack spacing={2}>
                  <Typography variant="h6">Password</Typography>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      label="Password"
                      name="password"
                      value={formData.password}
                      size="small"
                      fullWidth
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <Button
                      variant="outlined"
                      onClick={generatePassword}
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Generate
                    </Button>
                  </Box>
                </Stack>
              </Paper>
            </Stack>
          </Box>

          <ButtonControls>
            <Button type="submit" variant="contained" color="primary">
              Create User
            </Button>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
          </ButtonControls>
        </Box>
      </SlidingSidebar>
    </>
  );
};

export default AddBA;
